// Angular Files
import { NgModule } from '@angular/core';

// Component Modules
import { PublicPortalHeaderModule } from './public-portal-header/public-portal-header.component.module';
import { PublicPortalWelcomeModule } from './public-portal-welcome/public-portal-welcome.component.module';
import { PublicPortalFooterModule } from './public-portal-footer/public-portal-footer.component.module';

@NgModule({
    imports: [
        PublicPortalHeaderModule,
        PublicPortalWelcomeModule,
        PublicPortalFooterModule
    ],
    exports: [
        PublicPortalHeaderModule,
        PublicPortalWelcomeModule,
        PublicPortalFooterModule
    ]
})
export class PublicPortalComponentsModule { }